import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc-schedule.ui.list.delete-schedule.title',
		defaultMessage: 'Delete schedule',
		description: 'Title for delete schedule modal.',
	},
	explanation: {
		id: 'eoc-schedule.ui.list.delete-schedule.explanation',
		defaultMessage: 'Are you sure you want to delete the schedule <bold>{scheduleName}</bold>?',
		description: 'Explanation for what "Delete schedule" does.',
	},
});

export { messages };
